// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-header-img {
    float: left;
    width: 120px;
    height: 120px;
    overflow: hidden;
    position: relative;
    z-index: 10;
    margin: 0 0 -20px;
    padding: 3px;
    border-radius: 4px;
    background: #fff
}

.profile-header-img img {
    max-width: 100%
}

.profile-header-info h4 {
    font-weight: 500;
    color: #fff
}

.profile-header-img+.profile-header-info {
    margin-left: 140px
}

.profile-header .profile-header-content,
.profile-header .profile-header-tab {
    position: relative
}

.b-minus-1,
.b-minus-10,
.b-minus-2,
.b-minus-3,
.b-minus-4,
.b-minus-5,
.b-minus-6,
.b-minus-7,
.b-minus-8,
.b-minus-9,
.b-plus-1,
.b-plus-10,
.b-plus-2,
.b-plus-3,
.b-plus-4,
.b-plus-5,
.b-plus-6,
.b-plus-7,
.b-plus-8,
.b-plus-9,
.l-minus-1,
.l-minus-2,
.l-minus-3,
.l-minus-4,
.l-minus-5,
.l-minus-6,
.l-minus-7,
.l-minus-8,
.l-minus-9,
.l-plus-1,
.l-plus-10,
.l-plus-2,
.l-plus-3,
.l-plus-4,
.l-plus-5,
.l-plus-6,
.l-plus-7,
.l-plus-8,
.l-plus-9,
.r-minus-1,
.r-minus-10,
.r-minus-2,
.r-minus-3,
.r-minus-4,
.r-minus-5,
.r-minus-6,
.r-minus-7,
.r-minus-8,
.r-minus-9,
.r-plus-1,
.r-plus-10,
.r-plus-2,
.r-plus-3,
.r-plus-4,
.r-plus-5,
.r-plus-6,
.r-plus-7,
.r-plus-8,
.r-plus-9,
.t-minus-1,
.t-minus-10,
.t-minus-2,
.t-minus-3,
.t-minus-4,
.t-minus-5,
.t-minus-6,
.t-minus-7,
.t-minus-8,
.t-minus-9,
.t-plus-1,
.t-plus-10,
.t-plus-2,
.t-plus-3,
.t-plus-4,
.t-plus-5,
.t-plus-6,
.t-plus-7,
.t-plus-8,
.t-plus-9 {
    position: relative !important
}

.profile-header .profile-header-tab {
    background: #fff;
    list-style-type: none;
    margin: -10px 0 0;
    padding: 0 0 0 140px;
    white-space: nowrap;
    border-radius: 0
}

.text-ellipsis,
.text-nowrap {
    white-space: nowrap !important
}

.profile-header .profile-header-tab>li {
    display: inline-block;
    margin: 0
}

.profile-header .profile-header-tab>li>a {
    display: block;
    color: #929ba1;
    line-height: 20px;
    padding: 10px 20px;
    text-decoration: none;
    font-weight: 700;
    font-size: 12px;
    border: none
}

.profile-header .profile-header-tab>li.active>a,
.profile-header .profile-header-tab>li>a.active {
    color: #242a30
}

.profile-content {
    padding: 25px;
    border-radius: 4px
}

.profile-content:after,
.profile-content:before {
    content: '';
    display: table;
    clear: both
}

.profile-content .tab-content,
.profile-content .tab-pane {
    background: 0 0
}

.profile-left {
    width: 200px;
    float: left
}

.profile-right {
    margin-left: 240px;
    padding-right: 20px
}

.profile-image {
    height: 175px;
    line-height: 175px;
    text-align: center;
    font-size: 72px;
    margin-bottom: 10px;
    border: 2px solid #E2E7EB;
    overflow: hidden;
    border-radius: 4px
}

.profile-image img {
    display: block;
    max-width: 100%
}

.profile-highlight {
    padding: 12px 15px;
    background: #FEFDE1;
    border-radius: 4px
}

.profile-highlight h4 {
    margin: 0 0 7px;
    font-size: 12px;
    font-weight: 700
}

.table.table-profile>thead>tr>th {
    border-bottom: none !important
}

.table.table-profile>thead>tr>th h4 {
    font-size: 20px;
    margin-top: 0
}

.table.table-profile>thead>tr>th h4 small {
    display: block;
    font-size: 12px;
    font-weight: 400;
    margin-top: 5px
}

.table.table-profile>tbody>tr>td,
.table.table-profile>thead>tr>th {
    border: none;
    padding-top: 7px;
    padding-bottom: 7px;
    color: #242a30;
    background: 0 0
}

.table.table-profile>tbody>tr>td.field {
    width: 20%;
    text-align: right;
    font-weight: 600;
    color: #2d353c
}

.table.table-profile>tbody>tr.highlight>td {
    border-top: 1px solid #b9c3ca;
    border-bottom: 1px solid #b9c3ca
}

.table.table-profile>tbody>tr.divider>td {
    padding: 0 !important;
    height: 10px
}

.profile-section+.profile-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #b9c3ca
}

.profile-section:after,
.profile-section:before {
    content: '';
    display: table;
    clear: both
}

.profile-section .title {
    font-size: 20px;
    margin: 0 0 15px
}

.profile-section .title small {
    font-weight: 400
}

body.flat-black {
    background: #E7E7E7
}

.flat-black .navbar.navbar-inverse {
    background: #212121
}

.flat-black .navbar.navbar-inverse .navbar-form .form-control {
    background: #4a4a4a;
    border-color: #4a4a4a
}

.flat-black .sidebar,
.flat-black .sidebar-bg {
    background: #3A3A3A
}

.flat-black .page-with-light-sidebar .sidebar,
.flat-black .page-with-light-sidebar .sidebar-bg {
    background: #fff
}

.flat-black .sidebar .nav>li>a {
    color: #b2b2b2
}

.flat-black .sidebar.sidebar-grid .nav>li>a {
    border-bottom: 1px solid #474747;
    border-top: 1px solid #474747
}

.flat-black .sidebar .active .sub-menu>li.active>a,
.flat-black .sidebar .nav>li.active>a,
.flat-black .sidebar .nav>li>a:focus,
.flat-black .sidebar .nav>li>a:hover,
.flat-black .sidebar .sub-menu>li>a:focus,
.flat-black .sidebar .sub-menu>li>a:hover,
.sidebar .nav>li.nav-profile>a {
    color: #fff
}

.flat-black .sidebar .sub-menu>li>a,
.flat-black .sidebar .sub-menu>li>a:before {
    color: #999
}

.flat-black .page-with-light-sidebar .sidebar .active .sub-menu>li.active>a,
.flat-black .page-with-light-sidebar .sidebar .active .sub-menu>li.active>a:focus,
.flat-black .page-with-light-sidebar .sidebar .active .sub-menu>li.active>a:hover,
.flat-black .page-with-light-sidebar .sidebar .nav>li.active>a,
.flat-black .page-with-light-sidebar .sidebar .nav>li.active>a:focus,
.flat-black .page-with-light-sidebar .sidebar .nav>li.active>a:hover {
    color: #000
}

.flat-black .page-sidebar-minified .sidebar .nav>li.has-sub:focus>a,
.flat-black .page-sidebar-minified .sidebar .nav>li.has-sub:hover>a {
    background: #323232
}

.flat-black .page-sidebar-minified .sidebar .nav li.has-sub>.sub-menu,
.flat-black .sidebar .nav>li.active>a,
.flat-black .sidebar .nav>li.active>a:focus,
.flat-black .sidebar .nav>li.active>a:hover,
.flat-black .sidebar .nav>li.nav-profile,
.flat-black .sidebar .sub-menu>li.has-sub>a:before,
.flat-black .sidebar .sub-menu>li:before,
.flat-black .sidebar .sub-menu>li>a:after {
    background: #2A2A2A
}

.flat-black .page-sidebar-minified .sidebar .sub-menu>li:before,
.flat-black .page-sidebar-minified .sidebar .sub-menu>li>a:after {
    background: #3e3e3e
}

.flat-black .sidebar .nav>li.nav-profile .cover.with-shadow:before {
    background: rgba(42, 42, 42, .75)
}

.bg-white {
    background-color: #fff !important;
}

.p-10 {
    padding: 10px !important;
}

.media.media-xs .media-object {
    width: 32px;
}

.m-b-2 {
    margin-bottom: 2px !important;
}

.media>.media-left,
.media>.pull-left {
    padding-right: 15px;
}

.media-body,
.media-left,
.media-right {
    display: table-cell;
    vertical-align: top;
}

select.form-control:not([size]):not([multiple]) {
    /* height: 34px; */
}

.form-control.input-inline {
    display: inline;
    width: auto;
    padding: 0 7px;
}


.timeline {
    list-style-type: none;
    margin: 0;
    padding: 0;
    position: relative
}

.timeline:before {
    content: '';
    position: absolute;
    top: 5px;
    bottom: 5px;
    width: 3px;
    background: #f7c32e;
    left: 20%;
    /* margin-left: -2.5px */
}

.timeline>li {
    position: relative;
    min-height: 50px;
    padding: 20px 0
}

.timeline .timeline-time {
    position: absolute;
    left: 0;
    width: 18%;
    text-align: right;
    top: 30px
}

.timeline .timeline-time .date,
.timeline .timeline-time .time {
    display: block;
    font-weight: 600
}

.timeline .timeline-time .date {
    line-height: 16px;
    font-size: 12px
}

.timeline .timeline-time .time {
    line-height: 24px;
    font-size: 20px;
    color: #242a30
}

.timeline .timeline-icon {
    left: 15%;
    position: absolute;
    width: 10%;
    text-align: center;
    top: 40px
}

.timeline .timeline-icon a {
    text-decoration: none;
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 20px;
    background: #f7c32e;
    line-height: 10px;
    color: #fff;
    font-size: 14px;
    border: 5px solid lightgray;
    transition: border-color .2s linear;
    -webkit-transition: border-color .2s linear;
    -moz-transition: border-color .2s linear;
    -ms-transition: border-color .2s linear;
    -o-transition: border-color .2s linear;
}

.timeline .timeline-body {
    margin-left: 23%;
    /* margin-right: 17%; */
    background: #EFF2F6;
    position: relative;
    padding: 20px 25px;
    border-radius: 6px
}

.timeline .timeline-body:before {
    content: '';
    display: block;
    position: absolute;
    border: 10px solid transparent;
    border-right-color: #fff;
    left: -20px;
    top: 20px
}

.timeline .timeline-body>div+div {
    margin-top: 15px
}

.timeline .timeline-body>div+div:last-child {
    margin-bottom: -20px;
    padding-bottom: 20px;
    border-radius: 0 0 6px 6px
}

.timeline-header {
    padding-bottom: 10px;
    border-bottom: 1px solid #e2e7eb;
    line-height: 30px
}

.timeline-header .userimage {
    float: left;
    width: 34px;
    height: 34px;
    border-radius: 40px;
    overflow: hidden;
    margin: -2px 10px -2px 0
}

.timeline-header .username {
    font-size: 18px;
    font-weight: 600
}

.timeline-header .username,
.timeline-header .username a {
    color: #2d353c
}

.timeline img {
    max-width: 100%;
    display: block
}

.timeline-content {
    letter-spacing: .25px;
    line-height: 18px;
    /* font-size: 13px */
}

.timeline-content:after,
.timeline-content:before {
    content: '';
    display: table;
    clear: both
}

.timeline-title {
    margin-top: 0
}

.timeline-footer {
    background: #fff;
    border-top: 1px solid #e2e7ec;
    padding-top: 15px
}

.timeline-footer a:not(.btn) {
    color: #575d63
}

.timeline-footer a:not(.btn):focus,
.timeline-footer a:not(.btn):hover {
    color: #2d353c
}

.timeline-likes {
    color: #6d767f;
    font-weight: 600;
    font-size: 12px
}

.timeline-likes .stats-right {
    float: right
}

.timeline-likes .stats-total {
    display: inline-block;
    line-height: 20px
}

.timeline-likes .stats-icon {
    float: left;
    margin-right: 5px;
    font-size: 9px
}

.timeline-likes .stats-icon+.stats-icon {
    margin-left: -2px
}

.timeline-likes .stats-text {
    line-height: 20px
}

.timeline-likes .stats-text+.stats-text {
    margin-left: 15px
}

.timeline-comment-box {
    background: #f2f3f4;
    margin-left: -25px;
    margin-right: -25px;
    padding: 20px 25px
}

.timeline-comment-box .user {
    float: left;
    width: 34px;
    height: 34px;
    overflow: hidden;
    border-radius: 30px
}

.timeline-comment-box .user img {
    max-width: 100%;
    max-height: 100%
}

.timeline-comment-box .user+.input {
    margin-left: 44px
}

.lead {
    margin-bottom: 20px;
    font-size: 21px;
    font-weight: 300;
    line-height: 1.4;
}

.text-danger,
.text-red {
    color: #ff5b57 !important;
}`, "",{"version":3,"sources":["webpack://./src/css/publication.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+EI;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B","sourcesContent":[".profile-header-img {\r\n    float: left;\r\n    width: 120px;\r\n    height: 120px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    z-index: 10;\r\n    margin: 0 0 -20px;\r\n    padding: 3px;\r\n    border-radius: 4px;\r\n    background: #fff\r\n}\r\n\r\n.profile-header-img img {\r\n    max-width: 100%\r\n}\r\n\r\n.profile-header-info h4 {\r\n    font-weight: 500;\r\n    color: #fff\r\n}\r\n\r\n.profile-header-img+.profile-header-info {\r\n    margin-left: 140px\r\n}\r\n\r\n.profile-header .profile-header-content,\r\n.profile-header .profile-header-tab {\r\n    position: relative\r\n}\r\n\r\n.b-minus-1,\r\n.b-minus-10,\r\n.b-minus-2,\r\n.b-minus-3,\r\n.b-minus-4,\r\n.b-minus-5,\r\n.b-minus-6,\r\n.b-minus-7,\r\n.b-minus-8,\r\n.b-minus-9,\r\n.b-plus-1,\r\n.b-plus-10,\r\n.b-plus-2,\r\n.b-plus-3,\r\n.b-plus-4,\r\n.b-plus-5,\r\n.b-plus-6,\r\n.b-plus-7,\r\n.b-plus-8,\r\n.b-plus-9,\r\n.l-minus-1,\r\n.l-minus-2,\r\n.l-minus-3,\r\n.l-minus-4,\r\n.l-minus-5,\r\n.l-minus-6,\r\n.l-minus-7,\r\n.l-minus-8,\r\n.l-minus-9,\r\n.l-plus-1,\r\n.l-plus-10,\r\n.l-plus-2,\r\n.l-plus-3,\r\n.l-plus-4,\r\n.l-plus-5,\r\n.l-plus-6,\r\n.l-plus-7,\r\n.l-plus-8,\r\n.l-plus-9,\r\n.r-minus-1,\r\n.r-minus-10,\r\n.r-minus-2,\r\n.r-minus-3,\r\n.r-minus-4,\r\n.r-minus-5,\r\n.r-minus-6,\r\n.r-minus-7,\r\n.r-minus-8,\r\n.r-minus-9,\r\n.r-plus-1,\r\n.r-plus-10,\r\n.r-plus-2,\r\n.r-plus-3,\r\n.r-plus-4,\r\n.r-plus-5,\r\n.r-plus-6,\r\n.r-plus-7,\r\n.r-plus-8,\r\n.r-plus-9,\r\n.t-minus-1,\r\n.t-minus-10,\r\n.t-minus-2,\r\n.t-minus-3,\r\n.t-minus-4,\r\n.t-minus-5,\r\n.t-minus-6,\r\n.t-minus-7,\r\n.t-minus-8,\r\n.t-minus-9,\r\n.t-plus-1,\r\n.t-plus-10,\r\n.t-plus-2,\r\n.t-plus-3,\r\n.t-plus-4,\r\n.t-plus-5,\r\n.t-plus-6,\r\n.t-plus-7,\r\n.t-plus-8,\r\n.t-plus-9 {\r\n    position: relative !important\r\n}\r\n\r\n.profile-header .profile-header-tab {\r\n    background: #fff;\r\n    list-style-type: none;\r\n    margin: -10px 0 0;\r\n    padding: 0 0 0 140px;\r\n    white-space: nowrap;\r\n    border-radius: 0\r\n}\r\n\r\n.text-ellipsis,\r\n.text-nowrap {\r\n    white-space: nowrap !important\r\n}\r\n\r\n.profile-header .profile-header-tab>li {\r\n    display: inline-block;\r\n    margin: 0\r\n}\r\n\r\n.profile-header .profile-header-tab>li>a {\r\n    display: block;\r\n    color: #929ba1;\r\n    line-height: 20px;\r\n    padding: 10px 20px;\r\n    text-decoration: none;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    border: none\r\n}\r\n\r\n.profile-header .profile-header-tab>li.active>a,\r\n.profile-header .profile-header-tab>li>a.active {\r\n    color: #242a30\r\n}\r\n\r\n.profile-content {\r\n    padding: 25px;\r\n    border-radius: 4px\r\n}\r\n\r\n.profile-content:after,\r\n.profile-content:before {\r\n    content: '';\r\n    display: table;\r\n    clear: both\r\n}\r\n\r\n.profile-content .tab-content,\r\n.profile-content .tab-pane {\r\n    background: 0 0\r\n}\r\n\r\n.profile-left {\r\n    width: 200px;\r\n    float: left\r\n}\r\n\r\n.profile-right {\r\n    margin-left: 240px;\r\n    padding-right: 20px\r\n}\r\n\r\n.profile-image {\r\n    height: 175px;\r\n    line-height: 175px;\r\n    text-align: center;\r\n    font-size: 72px;\r\n    margin-bottom: 10px;\r\n    border: 2px solid #E2E7EB;\r\n    overflow: hidden;\r\n    border-radius: 4px\r\n}\r\n\r\n.profile-image img {\r\n    display: block;\r\n    max-width: 100%\r\n}\r\n\r\n.profile-highlight {\r\n    padding: 12px 15px;\r\n    background: #FEFDE1;\r\n    border-radius: 4px\r\n}\r\n\r\n.profile-highlight h4 {\r\n    margin: 0 0 7px;\r\n    font-size: 12px;\r\n    font-weight: 700\r\n}\r\n\r\n.table.table-profile>thead>tr>th {\r\n    border-bottom: none !important\r\n}\r\n\r\n.table.table-profile>thead>tr>th h4 {\r\n    font-size: 20px;\r\n    margin-top: 0\r\n}\r\n\r\n.table.table-profile>thead>tr>th h4 small {\r\n    display: block;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    margin-top: 5px\r\n}\r\n\r\n.table.table-profile>tbody>tr>td,\r\n.table.table-profile>thead>tr>th {\r\n    border: none;\r\n    padding-top: 7px;\r\n    padding-bottom: 7px;\r\n    color: #242a30;\r\n    background: 0 0\r\n}\r\n\r\n.table.table-profile>tbody>tr>td.field {\r\n    width: 20%;\r\n    text-align: right;\r\n    font-weight: 600;\r\n    color: #2d353c\r\n}\r\n\r\n.table.table-profile>tbody>tr.highlight>td {\r\n    border-top: 1px solid #b9c3ca;\r\n    border-bottom: 1px solid #b9c3ca\r\n}\r\n\r\n.table.table-profile>tbody>tr.divider>td {\r\n    padding: 0 !important;\r\n    height: 10px\r\n}\r\n\r\n.profile-section+.profile-section {\r\n    margin-top: 20px;\r\n    padding-top: 20px;\r\n    border-top: 1px solid #b9c3ca\r\n}\r\n\r\n.profile-section:after,\r\n.profile-section:before {\r\n    content: '';\r\n    display: table;\r\n    clear: both\r\n}\r\n\r\n.profile-section .title {\r\n    font-size: 20px;\r\n    margin: 0 0 15px\r\n}\r\n\r\n.profile-section .title small {\r\n    font-weight: 400\r\n}\r\n\r\nbody.flat-black {\r\n    background: #E7E7E7\r\n}\r\n\r\n.flat-black .navbar.navbar-inverse {\r\n    background: #212121\r\n}\r\n\r\n.flat-black .navbar.navbar-inverse .navbar-form .form-control {\r\n    background: #4a4a4a;\r\n    border-color: #4a4a4a\r\n}\r\n\r\n.flat-black .sidebar,\r\n.flat-black .sidebar-bg {\r\n    background: #3A3A3A\r\n}\r\n\r\n.flat-black .page-with-light-sidebar .sidebar,\r\n.flat-black .page-with-light-sidebar .sidebar-bg {\r\n    background: #fff\r\n}\r\n\r\n.flat-black .sidebar .nav>li>a {\r\n    color: #b2b2b2\r\n}\r\n\r\n.flat-black .sidebar.sidebar-grid .nav>li>a {\r\n    border-bottom: 1px solid #474747;\r\n    border-top: 1px solid #474747\r\n}\r\n\r\n.flat-black .sidebar .active .sub-menu>li.active>a,\r\n.flat-black .sidebar .nav>li.active>a,\r\n.flat-black .sidebar .nav>li>a:focus,\r\n.flat-black .sidebar .nav>li>a:hover,\r\n.flat-black .sidebar .sub-menu>li>a:focus,\r\n.flat-black .sidebar .sub-menu>li>a:hover,\r\n.sidebar .nav>li.nav-profile>a {\r\n    color: #fff\r\n}\r\n\r\n.flat-black .sidebar .sub-menu>li>a,\r\n.flat-black .sidebar .sub-menu>li>a:before {\r\n    color: #999\r\n}\r\n\r\n.flat-black .page-with-light-sidebar .sidebar .active .sub-menu>li.active>a,\r\n.flat-black .page-with-light-sidebar .sidebar .active .sub-menu>li.active>a:focus,\r\n.flat-black .page-with-light-sidebar .sidebar .active .sub-menu>li.active>a:hover,\r\n.flat-black .page-with-light-sidebar .sidebar .nav>li.active>a,\r\n.flat-black .page-with-light-sidebar .sidebar .nav>li.active>a:focus,\r\n.flat-black .page-with-light-sidebar .sidebar .nav>li.active>a:hover {\r\n    color: #000\r\n}\r\n\r\n.flat-black .page-sidebar-minified .sidebar .nav>li.has-sub:focus>a,\r\n.flat-black .page-sidebar-minified .sidebar .nav>li.has-sub:hover>a {\r\n    background: #323232\r\n}\r\n\r\n.flat-black .page-sidebar-minified .sidebar .nav li.has-sub>.sub-menu,\r\n.flat-black .sidebar .nav>li.active>a,\r\n.flat-black .sidebar .nav>li.active>a:focus,\r\n.flat-black .sidebar .nav>li.active>a:hover,\r\n.flat-black .sidebar .nav>li.nav-profile,\r\n.flat-black .sidebar .sub-menu>li.has-sub>a:before,\r\n.flat-black .sidebar .sub-menu>li:before,\r\n.flat-black .sidebar .sub-menu>li>a:after {\r\n    background: #2A2A2A\r\n}\r\n\r\n.flat-black .page-sidebar-minified .sidebar .sub-menu>li:before,\r\n.flat-black .page-sidebar-minified .sidebar .sub-menu>li>a:after {\r\n    background: #3e3e3e\r\n}\r\n\r\n.flat-black .sidebar .nav>li.nav-profile .cover.with-shadow:before {\r\n    background: rgba(42, 42, 42, .75)\r\n}\r\n\r\n.bg-white {\r\n    background-color: #fff !important;\r\n}\r\n\r\n.p-10 {\r\n    padding: 10px !important;\r\n}\r\n\r\n.media.media-xs .media-object {\r\n    width: 32px;\r\n}\r\n\r\n.m-b-2 {\r\n    margin-bottom: 2px !important;\r\n}\r\n\r\n.media>.media-left,\r\n.media>.pull-left {\r\n    padding-right: 15px;\r\n}\r\n\r\n.media-body,\r\n.media-left,\r\n.media-right {\r\n    display: table-cell;\r\n    vertical-align: top;\r\n}\r\n\r\nselect.form-control:not([size]):not([multiple]) {\r\n    /* height: 34px; */\r\n}\r\n\r\n.form-control.input-inline {\r\n    display: inline;\r\n    width: auto;\r\n    padding: 0 7px;\r\n}\r\n\r\n\r\n.timeline {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative\r\n}\r\n\r\n.timeline:before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 5px;\r\n    bottom: 5px;\r\n    width: 3px;\r\n    background: #f7c32e;\r\n    left: 20%;\r\n    /* margin-left: -2.5px */\r\n}\r\n\r\n.timeline>li {\r\n    position: relative;\r\n    min-height: 50px;\r\n    padding: 20px 0\r\n}\r\n\r\n.timeline .timeline-time {\r\n    position: absolute;\r\n    left: 0;\r\n    width: 18%;\r\n    text-align: right;\r\n    top: 30px\r\n}\r\n\r\n.timeline .timeline-time .date,\r\n.timeline .timeline-time .time {\r\n    display: block;\r\n    font-weight: 600\r\n}\r\n\r\n.timeline .timeline-time .date {\r\n    line-height: 16px;\r\n    font-size: 12px\r\n}\r\n\r\n.timeline .timeline-time .time {\r\n    line-height: 24px;\r\n    font-size: 20px;\r\n    color: #242a30\r\n}\r\n\r\n.timeline .timeline-icon {\r\n    left: 15%;\r\n    position: absolute;\r\n    width: 10%;\r\n    text-align: center;\r\n    top: 40px\r\n}\r\n\r\n.timeline .timeline-icon a {\r\n    text-decoration: none;\r\n    width: 20px;\r\n    height: 20px;\r\n    display: inline-block;\r\n    border-radius: 20px;\r\n    background: #f7c32e;\r\n    line-height: 10px;\r\n    color: #fff;\r\n    font-size: 14px;\r\n    border: 5px solid lightgray;\r\n    transition: border-color .2s linear;\r\n    -webkit-transition: border-color .2s linear;\r\n    -moz-transition: border-color .2s linear;\r\n    -ms-transition: border-color .2s linear;\r\n    -o-transition: border-color .2s linear;\r\n}\r\n\r\n.timeline .timeline-body {\r\n    margin-left: 23%;\r\n    /* margin-right: 17%; */\r\n    background: #EFF2F6;\r\n    position: relative;\r\n    padding: 20px 25px;\r\n    border-radius: 6px\r\n}\r\n\r\n.timeline .timeline-body:before {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    border: 10px solid transparent;\r\n    border-right-color: #fff;\r\n    left: -20px;\r\n    top: 20px\r\n}\r\n\r\n.timeline .timeline-body>div+div {\r\n    margin-top: 15px\r\n}\r\n\r\n.timeline .timeline-body>div+div:last-child {\r\n    margin-bottom: -20px;\r\n    padding-bottom: 20px;\r\n    border-radius: 0 0 6px 6px\r\n}\r\n\r\n.timeline-header {\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid #e2e7eb;\r\n    line-height: 30px\r\n}\r\n\r\n.timeline-header .userimage {\r\n    float: left;\r\n    width: 34px;\r\n    height: 34px;\r\n    border-radius: 40px;\r\n    overflow: hidden;\r\n    margin: -2px 10px -2px 0\r\n}\r\n\r\n.timeline-header .username {\r\n    font-size: 18px;\r\n    font-weight: 600\r\n}\r\n\r\n.timeline-header .username,\r\n.timeline-header .username a {\r\n    color: #2d353c\r\n}\r\n\r\n.timeline img {\r\n    max-width: 100%;\r\n    display: block\r\n}\r\n\r\n.timeline-content {\r\n    letter-spacing: .25px;\r\n    line-height: 18px;\r\n    /* font-size: 13px */\r\n}\r\n\r\n.timeline-content:after,\r\n.timeline-content:before {\r\n    content: '';\r\n    display: table;\r\n    clear: both\r\n}\r\n\r\n.timeline-title {\r\n    margin-top: 0\r\n}\r\n\r\n.timeline-footer {\r\n    background: #fff;\r\n    border-top: 1px solid #e2e7ec;\r\n    padding-top: 15px\r\n}\r\n\r\n.timeline-footer a:not(.btn) {\r\n    color: #575d63\r\n}\r\n\r\n.timeline-footer a:not(.btn):focus,\r\n.timeline-footer a:not(.btn):hover {\r\n    color: #2d353c\r\n}\r\n\r\n.timeline-likes {\r\n    color: #6d767f;\r\n    font-weight: 600;\r\n    font-size: 12px\r\n}\r\n\r\n.timeline-likes .stats-right {\r\n    float: right\r\n}\r\n\r\n.timeline-likes .stats-total {\r\n    display: inline-block;\r\n    line-height: 20px\r\n}\r\n\r\n.timeline-likes .stats-icon {\r\n    float: left;\r\n    margin-right: 5px;\r\n    font-size: 9px\r\n}\r\n\r\n.timeline-likes .stats-icon+.stats-icon {\r\n    margin-left: -2px\r\n}\r\n\r\n.timeline-likes .stats-text {\r\n    line-height: 20px\r\n}\r\n\r\n.timeline-likes .stats-text+.stats-text {\r\n    margin-left: 15px\r\n}\r\n\r\n.timeline-comment-box {\r\n    background: #f2f3f4;\r\n    margin-left: -25px;\r\n    margin-right: -25px;\r\n    padding: 20px 25px\r\n}\r\n\r\n.timeline-comment-box .user {\r\n    float: left;\r\n    width: 34px;\r\n    height: 34px;\r\n    overflow: hidden;\r\n    border-radius: 30px\r\n}\r\n\r\n.timeline-comment-box .user img {\r\n    max-width: 100%;\r\n    max-height: 100%\r\n}\r\n\r\n.timeline-comment-box .user+.input {\r\n    margin-left: 44px\r\n}\r\n\r\n.lead {\r\n    margin-bottom: 20px;\r\n    font-size: 21px;\r\n    font-weight: 300;\r\n    line-height: 1.4;\r\n}\r\n\r\n.text-danger,\r\n.text-red {\r\n    color: #ff5b57 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
